const strings = {
  globalStrings: {
    male: "גבר",
    female: 'אשה',
    sunday: 'א',
    monday: 'ב',
    tuesday: 'ג',
    wednsday: 'ד',
    thursady: 'ה',
    friday: 'ו',
    sturday: 'ש',
    morning: 'בוקר',
    noon: 'צהריים',
    evening: 'ערב',
    english: 'אנגלית',
    arabic: 'ערבית',
    rusian: 'רוסית',
    french: 'צרפתית',
    //NEW
    languages: "שפות",
    city: "ישוב",
    toList: "לרשימה",
    search: "חיפוש",
    advanceSearch: "פתיחת חיפוש מתקדם",
    closeAdvancedSearch: "סגירת חיפוש מתקדם",
    chooseCity: "בחירת ישוב",
    canChooseCity: "ניתן לבחור יותר מישוב אחד",
    searchCity: "חיפוש ישוב",
    cityPlaceholder: "הקלד שם ישוב (אחד או יותר)",
    continue: "המשך",
    clear: "נקה",
    close: "סגירה",
    visitDays: "ימי קבלה",
    visitHours: "שעות קבלה",
    address: "כתובת",
    sortBy: "מיין לפי",
    moreResults: "עוד תוצאות",
    expand: "הרחבה",
    collapse: "צמצום",
    whatIsThis: "מה זה?",
    foundResultsAroundLocation: "לא נמצאו תוצאות התואמות את בקשתך.נמצאו תוצאות בקרבת מקום",
    foundMoreResultsAroundLocation: "נמצאו עוד תוצאות בקרבת מקום.",
    noResultsFound: "לא נמצאו תוצאות התואמות את בקשתך ניתן לשנות או להסיר חלק מהסננים כדי לקבל תוצאות",
    noMatchedItems: "אין ערכים תואמים.",
    selectItemFromList: "יש לבחור ערך מהרשימה",
    filterBy: "סינון לפי",
    distance: "מרחק",
    remove: "הסר",
    clearSearch: "נקה חיפוש",
    noResults: "אין ערכים תואמים",
    serviceToday: "מקבל קהל היום",
    foundOneResult: "נמצאה תוצאה אחת",
    networkError: "אירעה שגיאה בעת טעינת תוצאות החיפוש. נא לנסות שוב מאוחר יותר.",
  },
  searchDoctors: {
    medicalField: "תחום טיפול",
    subField: "תת תחום",
    name: "שם רופא/ה",
    doctorGender: "מגדר הרופא",
    chooseMedicalField: "בחירת תחום טיפול",
    canChooseMedicalField: "ניתן לבחור תחום טיפול אחד",
    searchMedicalField: "חיפוש תחום טיפול",
    chooseSubMedicalField: "בחירת תת תחום טיפול",
    canChooseSubMedicalField: "ניתן לבחור יותר מתת תחום טיפול אחד",
    searchSubMedicalField: "חיפוש תת תחום טיפול",
    allSubMedicalFields: "כל תתי התחומים",
    selectSubMedicalField: "לבחירת תת תחום ",
  },
  searchMedicalCenters: {
    name: "",
    medicalFieldPlaceholder: "",
  },
  searchOuterServices: {
    serviceProviderName: "שם נותן שירות",
    fieldOfService: "תחום שירות",
    serviceCode: "קוד שירות",
    serviceCodeInfo: "",
    chooseFieldOfService: "בחירת תחום שירות",
    canChooseFieldOfService: "ניתן לבחור תחום שירות אחד",
    searchOuterServiceInstruction: "אם ברשותך הפניה ניתן לחפש ישירות באמצעות קוד השירות",
    tooltipTitle: "קוד שירות",
    tooltipContent: "הסבר מסויים על קוד שירות",
    resultsForSearchedMedicalField: "התוצאות מוצגות עבור תחום שירות"
  },
  searchOperations: {
    searchDescription: "אם ברשותך קוד ניתוח ניתן לחפש ישירות בעזרת הקוד",
    operationGroup: "קבוצת ניתוח",
    operationName: "שם ניתוח",
    operationCode: "קוד ניתוח",
    operationCodeExplanation: "מה זה?",
    operationCodeExplanationModal: "dfdf",
    name: "שם רופא/ה",
    chooseOperationGroup: "בחירת קבוצת ניתוח",
    searchOperationGroup: "חיפוש קבוצת ניתוח",
    chooseOperationName: "בחירת שם ניתוח",
    searchOperationName: "חיפוש שם ניתוח",
    canChooseOperationGroup: "ניתן לבחור קבוצת ניתוח אחת",
    canChooseOperationName: "ניתן לבחור שם ניתוח אחד",
    requiredOperationGroup: "יש להזין שם ניתוח",
    requiredOperationName: "יש להזין קוד ניתוח",
  },

  globalSearchResults: {
    doctors: "רופאים",
    articlesAndDocuments: "כתבות ומסמכים",
    allResults: "לכל התוצאות",
    shaban: 'מנתחים',
    medicalCenters: "מרכזי רפואיים",
    entitlement: "זכאויות",
    medicines: "ציוד ותרופות",
    socialWorkers: "עובדים סוציאלים",
    outerServices: "מכונים",
    pharamcies: "בתי מרקחת",
    dental: "רופאי שיניים",
    optica: "אופטיקאים",
    emergency: "מרפאות דחופות",
    diet: "תזונה",
    emergencyWomen: "מרפאות דחופות לנשים",
    search: 'חיפוש',
    allSearchResults: 'כאן תוכלו למצוא את כל מה שאתם מחפשים'
  },

  doctorSearchResults: {
    tooltipTitle: "ביטוח משלים",
    tooltipContent: '<p>בדיקה</p>',
    doctorimPopupTitle: "זימון תור לרופא, מחוץ למרכז הרפואי של לאומית",
    doctorimPopupContent: `.כדי לזמן תור לרופא, עליך ללחוץ על כפתור "זימון תור" בתחתית העמוד .לחיצה על כפתור זה תעביר אותך לאתר בו מבוצע זימןן התור .בעת כניסה ראשונה לאתר "דוקתורים" נדרש לבצע רישום קצר ולאחריו ניתן לזמן תור`,
    navigateToAddress: "ניווט לכתובת",
    moreInfo: "עוד מידע",
    phoneAppointment: "תור בשיחת טלפון",
    videoAppointment: "תור בשיחת וידאו",
    getAppointment: "זימון תור",
    appointmentSystem: "התור ייקבע במערכת",
    doctorArrange: "רופא בהסדר",
    doctorRefund: "רופא בהחזר",
    licenseNum: "מספר רישיון",
    role: "תפקיד",
    callToOrder: "לזימון תור התקשרו למרפאה",
    callToMoked: "לקביעת תור התקשרו למוקד",
    selfPay1: "רופא יועץ בהסדר השתתפות עצמית של",
    selfPay2: 'ש"ח. ההשתתפות העצמית משולמת ישירות לרופא.',
    list: "רשימה",
    medicalField: "תחום טיפול",
    subMedicalField: "תת תחום טיפול",
    searchByDoctorName: "חיפוש לפי שם רופא/ה",
    doctorGender: "מגדר הרופא",
    showOnlySurgeons: "הצג רק רופאים מנתחים",
    arrangementRefund: "החזר / הסדר",
    showArrangement: "הצגת רופאים בהסדר",
    showRefund: "הצגת רופאים בהחזר",
    found: "נמצאו",
    results: "תוצאות",
    leumitDoctors: "רופאים לאומית",
    mashlimDoctors: "רופאים בביטוח המשלים",
    arrangementRefundInfo:
      'טקסט הסבר על ההבדל בין החזר והסדר. ניתן לקבל ייעוץ בהשתתפות העצמית הרשומה רק כאשר הרופא נותן את הייעוץ במסגרת מרפאות השר"פ. רופא יועץ בשר"פ אשר נתן את הייעוץ באופן פרטי במרפאתו ולא במרפאות השר"פ - התשלום לרופא יהיה פרטי ולא ניתן יהיה לקבל החזר בגינו מלאומית.',
    exteranlSortOrder: "התוצאות יציגו ראשית רופאים בהסדר ואז בהחזר.",
    resultsForSearchedMedicalField: "מוצגות תוצאות עבור תחום טיפול",
    toggleDoctorType: "כפתור בחירה בין רופאי לאומית לרופאים בביטוח המשלים",
  },
  medicalCentersSearchResults: {
    topExplanation: "שעות הפעילות של בתי המרקחת עשויות להשתנות, כדאי להתקשר ולברר לפני ההגעה.",
    navigateToAddress: "ניווט לכתובת",
    callToOrder: "יצירת קשר",
    callToClinic: "לזימון תור התקשרו למרפאה",
    servicesInClinic: "שירותים במרפאה",
    searchByName: "שם נותן השירות",
    found: "נמצאו",
    results: "תוצאות",
    inbranch: "בתוך המרכז הרפואי",
    participationAmount: "סכום השתתפות",
    healthServices: "סל בריאות",
    leumitSilver: "לאומית כסף",
    leumitGold: "לאומית זהב",
    chooseDeviceCategory: "בחירת קטגוריית מכשיר",
    noDeductible: "ללא השתתפות עצמית",
    nis: 'ש"ח',
    moreInfo: "למידע נוסף",
    chooseService: "בחירת שירות מרפאה",
    canChooseService: "ניתן לבחור יותר משירות אחד",
  },
  operationSearchResults: {
    address: "כתובת",
    shabanOperation: "מסלול שבן",
    publicOperation: "מסלול ציבורי",
    ParticipationFee: "סכום השתתפות",
    noParticipationFee: "ניתוח זה מבוצע במסלול ציבורי חינם",
    selfParticipationFee: "השתתפות עצמית",
    silver: "כסף",
    gold: "זהב",
    resultsForOperation: "התוצאות מוצגות עבור ניתוח",
    operationCode: "קוד ניתוח/קופה:",
    deductible: "השתתפות עצמית:",
    surgeonIsKupa: "ניתוח זה מבוצע במסלול ציבורי חינם",
    route: "מסלול",
    public: "ציבורי",
    shaban: "שב\"ן",
    callTheClinic: "התקשרו למרפאה",
    code: "קוד",
  },
  medicinesSearchResults: {
    medicinesAndEquipmentSearch: "חיפוש תרופות וציוד רפואי",
    medicinesAndEquipmentSearchRequiredSearch: "רצוי לחפש את שם התרופה באנגלית לקבלת תוצאות מיטביות",
    yarpaPriceToCustomer: "מחיר ירפא ליצרן",
    basketPrice: "מחיר בסל",
    priceNotInBasket: "מחיר לא בסל",
    leumitZhavav: "לאומית זהב",
    leumitSilver: "לאומית כסף",
    makat: "מק\"ט",
    termsCondition1: 'למכירה בכפוף להתוויה רפואית',
    termsCondition2: 'ללקוחות בעלי לאומית זהב הזכאים על פי הקרטריונים ובעלי ותק של חצי שנה לפחות',
  },
  entitlementSearch: {
    searchTitle: 'כדי שתוכלו לברר על זכויותיכם עומד לרשותכם מנוע חיפוש לכל המידע אודות סל השירותים המלא של לאומית',
    fieldService: 'תחום שירות',
    freeSearch: 'חיפוש חופשי',
    found: 'מוצגות',
    entitlements: 'תוצאות בתחום שירות',
    healthBasket: 'בסל הבריאות',
    silverLeumit: 'לאומית כסף',
    goldLeumit: 'לאומית זהב',
    entitlemenFreeText: 'תוצאות עבור חיפוש '
  },
  entitlementFieldLobby: {
    showAllEntitlements: 'הצגת כל הזכאויות',
    fieldLabel: 'חיפוש זכאויות בתחום השיניים',
    fieldResultName: 'תחום השיניים',
    placeholder: '',
    found: 'יש',
    entitlements: 'זכאויות ב',
  },
  errorMessages: {
    notice: 'שימו לב',
    requiredProperties: 'יש להזין שדות חובה',
    requiredFieldOfService: 'יש להזין תחום שירות',
    requiredServiceCode: 'יש להזין קוד שירות',
    freeTextSearchRequired: 'יש להזין טקסט חופשי לחיפוש',
  }
};

//var strings = staticStrings;
declare global {
  interface Window {
    STRINGS_globalStrings: any;
    STRINGS_globalSearchResults: any;
    STRINGS_searchDoctors: any;
    STRINGS_doctorSearchResults: any;
    STRINGS_searchMedicalCenter: any;
    STRINGS_medicalCenterSearchResults: any;
    STRINGS_searchOuterServices: any;
    STRINGS_searchOperations: any;
    STRINGS_OperationsSearchResults: any;
    STRINGS_medicinesSearchResults: any;
    STRINGS_entitlementSearch: any;
    STRINGS_entitlementFieldLobby: any;
    STRINGS_errorMessages: any;
  }
}


if (window.STRINGS_globalStrings) {
  strings.globalStrings = { ...strings.globalStrings, ...window.STRINGS_globalStrings };
}

if (window.STRINGS_globalSearchResults) {
  strings.globalSearchResults = { ...strings.globalSearchResults, ...window.STRINGS_globalSearchResults };
}

if (window.STRINGS_doctorSearchResults) {
  strings.doctorSearchResults = { ...strings.doctorSearchResults, ...window.STRINGS_doctorSearchResults };
}

if (window.STRINGS_searchDoctors) {
  strings.searchDoctors = { ...strings.searchDoctors, ...window.STRINGS_searchDoctors };
}

if (window.STRINGS_searchMedicalCenter) {
  strings.searchMedicalCenters = { ...strings.searchMedicalCenters, ...window.STRINGS_searchMedicalCenter };
}

if (window.STRINGS_medicalCenterSearchResults) {
  strings.medicalCentersSearchResults = { ...strings.medicalCentersSearchResults, ...window.STRINGS_medicalCenterSearchResults };
}

if (window.STRINGS_searchOuterServices) {
  strings.searchOuterServices = { ...strings.searchOuterServices, ...window.STRINGS_searchOuterServices };
}

if (window.STRINGS_searchOperations) {
  strings.searchOperations = { ...strings.searchOperations, ...window.STRINGS_searchOperations };
}

if (window.STRINGS_OperationsSearchResults) {
  strings.operationSearchResults = { ...strings.operationSearchResults, ...window.STRINGS_OperationsSearchResults };
}

if (window.STRINGS_medicinesSearchResults) {
  strings.medicinesSearchResults = { ...strings.medicinesSearchResults, ...window.STRINGS_medicinesSearchResults };
}

if (window.STRINGS_entitlementSearch) {
  strings.entitlementSearch = { ...strings.entitlementSearch, ...window.STRINGS_entitlementSearch };
}

if (window.STRINGS_entitlementFieldLobby) {
  strings.entitlementFieldLobby = { ...strings.entitlementFieldLobby, ...window.STRINGS_entitlementFieldLobby };
}

if (window.STRINGS_errorMessages) {
  strings.errorMessages = { ...strings.errorMessages, ...window.STRINGS_errorMessages };
}
export default strings;
